export const isTruthyEnvFlag = (value) =>
  ["1", "true"].includes(String(value || "").trim().toLowerCase());

export const shouldAlwaysShowSuccessfulSubmit = () =>
  isTruthyEnvFlag(process.env.ALWAYS_SHOW_SUCCESSFUL_SUBMIT);
